exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-panel[data-v-72761047]{display:flex;justify-content:flex-start;align-items:flex-end;padding:20px 20px 70px;color:var(--color);background-color:var(--bg-color);font-family:var(--font-mono);font-size:12px}.info-panel pre[data-v-72761047]{font-family:var(--font-mono);font-size:16px}.text[data-v-72761047]{max-width:320px}.title[data-v-72761047]{font-weight:700}@media (min-width:760px){.info-panel[data-v-72761047]{justify-content:flex-end;align-items:flex-start;padding:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-72761047&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/InfoPanel.vue
// module id = 13
// module chunks = 0